import { Container, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTable from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  createStockIssue,
  getStockIssues,
  updateStockIssues,
  updateStockIssueStatusById,
} from "../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../util/AppColors";
import { requestFilters, requestTypeList } from "../../../util/dropList";
import { requestAndTransferRetriveEnum } from "../../../util/enum";
import StockRequestModal from "../../CommonScreens/Stock/StockRequestModal";

const tblHdrs = [
  "sNo",
  "requestType",
  "location",
  "requestedBy",
  "requestedDate",
  "issueDate",
  "status",
  "extraStatus",
];
const tblHdrsOthers = [
  "sNo",
  "requestType",
  "location",
  "requestedBy",
  "requestedDate",
  "status",
];
const reqTxt = "This field is required";
const initObj = {
  itemName: null,
  itemNameErr: false,
  name: null,
  quantity: null,
  nameErr: false,
  qtyErr: false,
  issQtyErr: false,
  issueQuantity: null,
  fromLocation: null,
  fromLocationErr: false,
  toLocation: null,
  toLocationErr: false,
  batchNumber: null,
  batchErr: false,
};

const initVal = {
  requestType: requestTypeList[1],
  requestTypeError: false,
  location: null,
  locationErr: false,
  requestedBy: null,
  requestedDate: new Date(),
  requestedByErr: false,
};
const requestAllowedCategories = [
  "medication",
  "diet",
  "nutrition and supplements",
  "fluid therapy",
  "other parasite treatment",
  "deworming",
  "flea & tick treatment",
];
const defObj = { facilities: [], locations: [], stocks: [], dataSharing: {} };

const StockRequest = () => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [modValues, setModValues] = useState(initVal);
  const [addedList, setAddedList] = useState([{ ...initObj, i: 0 }]);
  const [modVsble, setModVsble] = useState(false);
  const [canModVsble, setCanModVsble] = useState(false);
  const [issueModVsble, setIssueModVsble] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [reasonModVsble, setReasonModVsble] = useState(false);
  const [subItem, setSubItem] = useState(null);
  const [reason, setReason] = useState({ value: "", error: false });
  const [isPreview, setIsPreview] = useState(false);
  const [rejectModVsble, setRejectModVsble] = useState(false);
  const [selFilterTypes, setSelFilterTypes] = useState(["All"]);
  const {
    stockIssues,
    clinicRoles,
    details: clinicDet,
  } = useSelector((state) => state?.clinic);
  const role = localStorage.getItem("role");
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const {
    facilities,
    locations,
    dataSharing,
    stocks: clinicStocks,
    vets,
  } = useMemo(() => {
    if (!mandateDataRaw) return defObj;
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        facilities: Array.isArray(reqData?.facilities)
          ? reqData?.facilities
          : [],
        locations: Array.isArray(reqData?.locations) ? reqData?.locations : [],
        dataSharing: reqData?.dataSharing ?? {},
        stocks: Array.isArray(reqData?.stocks) ? reqData?.stocks : [],
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
      };
    } catch {
      return defObj;
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    onApiCall();
  }, []);

  const getFacilites = () => {
    if (!facilities || facilities?.length === 0) return [];
    return facilities
      ?.filter((fac) => fac?.type?.toLowerCase() !== "devices")
      ?.map((fac) => ({ ...fac, value: fac?.name }));
  };

  const getLocationsByRequestType = (typ = null) => {
    if (locations?.length === 0 || !locations) return [];
    const reqTypes =
      typ === "Consumption" ? ["consumption"] : ["warehouse", "storage"];
    return locations
      ?.filter((li) => reqTypes?.includes(li?.locationType?.toLowerCase()))
      ?.map((loc) => ({
        name: loc?.locationName,
        value: loc?.locationName,
        id: loc?.id,
      }));
  };

  const getLocationList = (stockId = null, deptId = null) => {
    if (locations?.length === 0 || !locations) return [];
    if (stockId) {
      return clinicStocks
        ?.find((li) => li?.stockId === stockId)
        ?.stockBatch?.map((li) => ({
          name: li?.location,
          value: li?.location,
          id: li?.locationId,
          quantity: li?.quantity,
        }));
    }
    return locations
      ?.filter((li) => (deptId ? li?.departmentId === deptId : true))
      ?.map((loc) => ({
        name: loc?.locationName,
        value: loc?.locationName,
        id: loc?.id,
        quantity: loc?.quantity,
      }));
  };

  const getFacilityById = (facilityId = null) => {
    return facilities?.find((li) => li?.facilityId === facilityId) ?? null;
  };

  const getLocationsWithCategory = (stockId = null) => {
    if (locations?.length === 0 || !locations) return [];
    if (stockId) {
      const batList = clinicStocks
        ?.find((li) => li?.stockId === stockId)
        ?.stockBatch?.map((li) => ({
          ...li,
          name: li?.location,
          value: li?.location,
          id: li?.locationId,
          quantity: li?.quantity,
        }));
      const reqList = [];
      const primMatch = batList?.filter(
        (li) =>
          li?.locationId ===
          getFacilityById(
            modValues?.facility?.facilityId ?? selectedItem?.facilityId,
          )?.primaryStorage,
      );
      if (primMatch?.length > 0) {
        primMatch?.forEach((li) => {
          reqList.push({ ...li, group: "Primary" });
        });
      }
      const secMatch = batList?.filter(
        (li) =>
          li?.locationId ===
          getFacilityById(
            modValues?.facility?.facilityId ?? selectedItem?.facilityId,
          )?.secondaryStorage,
      );
      if (secMatch?.length > 0) {
        secMatch?.forEach((li) => {
          reqList.push({ ...li, group: "Secondary" });
        });
      }
      const othrMatch = batList?.filter(
        (li) =>
          li?.locationId !==
            getFacilityById(
              modValues?.facility?.facilityId ?? selectedItem?.facilityId,
            )?.secondaryStorage &&
          li?.locationId !==
            getFacilityById(
              modValues?.facility?.facilityId ?? selectedItem?.facilityId,
            )?.primaryStorage,
      );
      if (othrMatch?.length > 0) {
        othrMatch?.forEach((li) => {
          reqList.push({ ...li, group: "Other" });
        });
      }
      return reqList;
    }
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    return clinicStocks
      ?.find((stc) => stc?.stockId === stockId)
      ?.stockBatch?.map((bat) => {
        const reqLocation = locations?.find(
          (loc) => loc?.id === bat?.locationId,
        );
        return {
          name: bat?.batchNo,
          value: bat?.batchNo,
          id: bat?.batchId,
          subunits: bat?.subunits,
          quantity: bat?.quantity,
          locationId: bat?.locationId,
          locationName: reqLocation?.locationName ?? "",
        };
      });
  };

  const onApiCall = () => {
    dispatch(getStockIssues());
  };

  const handleCreate = () => {
    setModValues({
      ...initVal,
      requestedBy:
        role === "ROLE_CLINIC"
          ? { name: `${clinicDet?.name} (Clinic)`, value: clinicDet?.id }
          : null,
    });
    setModVsble(true);
  };

  const handleModClose = (typ) => {
    setModVsble(false);
    if (typ === "apiSuccess") onApiCall();
    // setAddedList([{ ...initObj, i: 0 }]);
    // setModValues(initVal);
  };

  const handleDelete = (si) => {
    setSelectedItem(si);
    setCanModVsble(true);
  };

  const handleIssue = (si, isView = false) => {
    const reqList = si?.stockIssueDetails?.map((li, i) => ({
      ...li,
      isRejected:
        li?.status?.toLowerCase() === "cancelled" ?? li?.rejected ?? false,
      issuedQuantity: li?.issueQuantity ?? 0,
      issueQuantity: li?.issueQuantity ?? li?.quantity,
      fromLocation: li?.fromLocation ?? null,
      toLocation: li?.toLocation ?? null,
      batchNumber: null,
      i,
    }));
    setSelectedItem(si);
    setAddedList(reqList);
    setIssueModVsble(true);
    setIsPreview(isView);
  };

  const getFilteredData = () => {
    if (stockIssues?.data?.length === 0) return [];
    const reqList = [...(stockIssues?.data ?? [])]
      ?.filter((li) => {
        const reqStaus = getStatus(li?.stockIssueDetails);
        const statMatch = selFilterTypes?.some(
          (type) => type?.toLowerCase() === reqStaus?.toLowerCase(),
        );
        if (selFilterTypes?.includes("All") || statMatch) return li;
      })
      ?.sort((a, b) => {
        const getSortDate = (item) => {
          if (!item?.createdDate) return new Date(0);
          const created = new Date(item?.createdDate);
          return Number.isNaN(created?.getTime()) ? new Date(0) : created;
        };
        return getSortDate(b) - getSortDate(a); // newest first
      });
    return reqList;
  };

  const getStatus = (details) => {
    if (
      details?.every(
        (li) =>
          ["cancelled"].includes(li?.status?.toLowerCase()) && !li?.rejected,
      )
    ) {
      return "Cancelled";
    }
    if (
      details?.every(
        (li) =>
          ["completed", "cancelled"].includes(li?.status?.toLowerCase()) ||
          li?.rejected,
      )
    ) {
      return "Completed";
    }
    if (details?.some((li) => li?.issueQuantity > 0)) {
      return "Partially Pending";
    }
    return "Pending";
    // const statusPriority = ["Pending", "Completed", "Cancelled"];
    // for (const status of statusPriority) {
    //   if (
    //     details.some((li) => li.status?.toLowerCase() === status?.toLowerCase())
    //   ) {
    //     return status;
    //   }
    // }
    // return "Pending"; // default if none match
  };

  const isDisabledStatus = (dta) => {
    return dta?.every(
      (li) =>
        ["completed", "cancelled"].includes(li?.status?.toLowerCase()) ||
        li?.rejected,
    );
  };

  const isCancelButtonShow = (dta) => {
    return dta?.every((li) => !li?.issueQuantity || li?.issueQuantity === 0);
  };

  const getVetById = (id) => {
    return vets?.find((li) => li?.doctorId === id);
  };

  const getFacilityNameById = (facId) => {
    return facilities?.find((fac) => fac?.facilityId === facId)?.name ?? "-";
  };

  const getLocationById = (id) => {
    return locations?.find((li) => li?.id === id)?.locationName ?? "";
  };

  const getTableHeaders = () => {
    return getFilteredData()?.map((si, i) => {
      return {
        ...si,
        sNo: i + 1,
        id: si?.issueId,
        requestedBy:
          typeof si?.requestedBy === "string"
            ? si?.requestedBy
            : si?.requestedName
              ? si?.requestedName
              : (getVetById(si?.requestedBy)?.name ?? ""),
        requestedDate: moment(new Date(si?.requestedDate)).format(
          "DD MMM YYYY",
        ),
        requestType: requestAndTransferRetriveEnum?.[si?.requestType],
        location: getLocationById(si?.locationId),
        // facility: getFacilityNameById(si?.facilityId),
        // department: getVetById(si?.requestedBy)?.department ?? "",
        status: getStatus(si?.stockIssueDetails),
        extraStatus: isDisabledStatus(si?.stockIssueDetails) ? (
          <div className="flex-row-ali-cen">
            <div>
              <CustomButton
                smallBtn
                text="View"
                onClick={() => handleIssue(si, true)}
              />
            </div>
          </div>
        ) : (
          <div className="flex-row-ali-cen">
            {isCancelButtonShow(si?.stockIssueDetails) ? (
              <div>
                <CustomButton
                  smallBtn
                  text="Cancel"
                  redBtn={si?.status === "Pending"}
                  onClick={() => handleDelete(si)}
                  // disabled={isDisabledStatus(si?.stockIssueDetails)}
                  // grayBtn={isDisabledStatus(si?.stockIssueDetails)}
                />
              </div>
            ) : null}
            <div
              className={
                isCancelButtonShow(si?.stockIssueDetails) ? "ml15" : ""
              }
            >
              <CustomButton
                smallBtn
                text="Issue"
                onClick={() => handleIssue(si, false)}
                disabled={isDisabledStatus(si?.stockIssueDetails)}
                grayBtn={isDisabledStatus(si?.stockIssueDetails)}
              />
            </div>
          </div>
        ),
      };
    });
  };

  const handleChange = (name, value) => {
    const reqObj = { ...modValues, [name]: value };
    if (name === "location") {
      reqObj.locationErr = value ? false : true;
    }
    if (name === "requestType") {
      reqObj.requestTypeError = value ? false : true;
      reqObj.location = null;
      setAddedList([{ ...initObj, i: 0 }]);
    }
    if (name === "requestedBy") {
      reqObj.requestedByErr = value ? false : true;
    }
    setModValues(reqObj);
  };

  const handleValidate = () => {
    const reqList = addedList?.map((li) => {
      const reqObj = {
        ...li,
        nameErr: li?.name === "" || li?.name?.length === 0 || !li?.name,
        qtyErr:
          li?.quantity === "" ||
          li?.quantity?.length === 0 ||
          !li?.quantity ||
          Number(li?.quantity) < 0,
        batchErr: !li?.batchNumber?.id,
      };
      return reqObj;
    });
    setAddedList(reqList);
    return reqList?.some((li) => li?.nameErr || li?.qtyErr || li?.batchErr);
  };

  const handleSave = () => {
    // if (role === "ROLE_CLINIC") {
    if (
      !modValues?.requestType?.value ||
      !modValues?.location?.id ||
      (role === "ROLE_CLINIC" ? !modValues?.requestedBy?.value : false)
    ) {
      setModValues({
        ...modValues,
        requestTypeError: !modValues?.requestType?.value,
        locationErr: !modValues?.location?.id,
        requestedByErr:
          role === "ROLE_CLINIC" ? !modValues?.requestedBy?.value : false,
      });
      return;
    }
    // }
    if (handleValidate() || addedList?.length === 0) return;
    const stockIssueDetails = addedList?.map((li) => {
      const batchList = clinicStocks?.find(
        (stc) => stc?.stockId === li?.stockId,
      )?.stockBatch;
      const reqBatch = li?.batchNumber?.id
        ? batchList?.find((bat) => bat?.batchId === li?.batchNumber?.id)
        : batchList?.[0];
      // const reqBatch = li?.batchNumber?.id
      //   ? batchList?.find((bat) => bat?.locationId === li?.batchNumber?.id)
      //   : li?.fromLocation?.id
      //   ? batchList?.find((bat) => bat?.locationId === li?.fromLocation?.id)
      //   : batchList?.[0];
      const reqObj = {
        itemName: li?.name ?? "",
        quantity: Number(li?.quantity ?? 1),
        status:
          role === "ROLE_CLINIC"
            ? li?.stockId
              ? "Completed"
              : "Pending"
            : "Pending",
        stockId: li?.stockId ?? null,
        batchId: batchList?.length > 0 ? (reqBatch?.batchId ?? null) : null,
        mode: "manual",
        isRejected: false,
        toLocationName: modValues?.location?.name ?? null,
        toLocationId: modValues?.location?.id ?? null,
      };
      if (role === "ROLE_CLINIC") {
        const reqBatch = getBatchById(li?.stockId, li?.batchNumber?.id);
        reqObj.issueQuantity = Number(li?.quantity ?? 1);
        reqObj.fromLocationName = reqBatch?.location ?? null;
        reqObj.fromLocationId = reqBatch?.locationId ?? null;
        // reqObj.toLocationName = modValues?.facility?.name ?? null;
        // reqObj.toLocationId = modValues?.facility?.primaryStorage ?? null;
      }
      return reqObj;
    });
    const reqObj = {
      stockIssueDetails,
      locationId: modValues?.location?.id,
      requestType: modValues?.requestType?.value,
      requestedDate: moment(new Date(modValues?.requestedDate)).format(
        "YYYY-MM-DD",
      ),
      requestedBy: modValues?.requestedBy?.value ?? profile?.id ?? null,
    };
    dispatch(createStockIssue(reqObj)).then((res) => {
      if (res?.payload) {
        dispatch(getStockIssues());
        handleModClose();
      }
    });
  };

  const handleAddNew = () => {
    setAddedList([...addedList, { ...initObj, i: addedList?.length }]);
  };

  const getPresList = () => {
    if (
      !clinicStocks ||
      clinicStocks?.length === 0 ||
      !modValues?.requestType?.value ||
      !modValues?.location?.id
    )
      return [];
    const reqList = clinicStocks?.filter((dta) => {
      const category = (dta?.category ?? "")?.toLowerCase()?.trim();
      const conMatch =
        modValues?.requestType?.value?.toLowerCase() === "consumption"
          ? dta?.autoConsumed
          : !dta?.autoConsumed;
      return (
        dta?.billable &&
        conMatch &&
        requestAllowedCategories?.includes(category)
      );
    });
    return reqList?.map((li) => ({
      name: li?.tradeName,
      value: li?.tradeName,
      stockId: li?.stockId,
      type: li?.category,
      productName: li?.productName,
    }));
  };

  const onChange = (name, value, i, stockId) => {
    const reqList = [...addedList];
    const reqObj = {
      ...reqList[i],
      [name]: value,
      itemNameErr:
        name === "itemName"
          ? value === "" || value?.length === 0 || !value
          : reqList[i]?.itemNameErr,
      nameErr:
        name === "name"
          ? value === "" || value?.length === 0 || !value
          : reqList[i]?.nameErr,
      qtyErr:
        name === "quantity"
          ? value === "" || value?.length === 0 || !value || Number(value) < 0
          : reqList[i]?.qtyErr,
      issQtyErr:
        name === "issueQuantity"
          ? value === "" || value?.length === 0 || !value || Number(value) < 1
          : reqList[i]?.issQtyErr,
      batchErr:
        name === "batchNumber"
          ? value === "" || value?.length === 0 || !value
          : reqList[i]?.batchErr,
      fromLocationErr:
        name === "fromLocation"
          ? value === "" || value?.length === 0 || !value
          : reqList[i]?.fromLocationErr,
      toLocationErr:
        name === "toLocation"
          ? value === "" || value?.length === 0 || !value
          : reqList[i]?.toLocationErr,
    };
    if (name === "name" && stockId) {
      reqObj.stockId = stockId;
      reqObj.batchNumber = getBatchList(stockId)?.[0] ?? null;
    }
    reqList[i] = reqObj;
    setAddedList(reqList);
  };

  const onCloseCanMod = () => {
    setCanModVsble(false);
    setSelectedItem(null);
  };

  const onConfrimCancel = () => {
    if (!selectedItem?.issueId) return;
    const data = selectedItem?.stockIssueDetails?.map((li) => ({
      ...li,
      quantity: li?.quantity,
      status: "Cancelled",
      itemName: li?.itemName,
    }));
    dispatch(
      updateStockIssueStatusById({
        id: selectedItem?.issueId,
        status: "Cancelled",
        data,
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseCanMod();
        onApiCall();
      }
    });
  };

  const onCloseIssueMod = () => {
    setIssueModVsble(false);
    setIsPreview(false);
    setSelectedItem(null);
    setAddedList([{ ...initObj, i: 0 }]);
  };

  const isIssueQuantiyNotValid = () => {
    const reqList = addedList?.map((li) => {
      const reqObj = {
        ...li,
        issQtyErr:
          li?.issueQuantity === "" ||
          li?.issueQuantity?.length === 0 ||
          !li?.issueQuantity ||
          Number(li?.issueQuantity) < 1,
      };
      return reqObj;
    });
    setAddedList(reqList);
    return addedList?.some((li) => li?.issQtyErr);
  };

  const onUpdateIssue = () => {
    if (isIssueQuantiyNotValid()) return;
    const data = addedList?.map((li) => {
      return {
        id: li?.id,
        issueQuantity: Number(li?.issueQuantity),
        quantity: li?.quantity,
        status: "Completed",
        itemName: li?.itemName,
        fromLocationName: li?.fromLocation?.value ?? null,
        fromLocationId: li?.fromLocation?.id ?? null,
        toLocationName: li?.toLocation?.value ?? null,
        toLocationId: li?.toLocation?.id ?? null,
        facilityId: li?.facilityId,
        // department: li?.department,
        mode: "manual",
        stockId: li?.stockId ?? null,
        batchId: li?.batchId ?? null,
      };
    });
    dispatch(updateStockIssues({ issueId: selectedItem?.issueId, data })).then(
      (res) => {
        if (res?.payload) {
          onCloseIssueMod();
          onApiCall();
        }
      },
    );
  };

  const handleFilterTypes = (name) => {
    const isPrev = selFilterTypes?.find((con) => con === name);
    if (name === "All") {
      setSelFilterTypes(["All"]);
    } else {
      let reqCons = isPrev
        ? selFilterTypes?.filter((con) => con !== name)
        : [...selFilterTypes, name];
      reqCons = reqCons?.filter((con) => con !== "All");
      if (reqCons?.length === 0) reqCons = ["All"];
      setSelFilterTypes(reqCons);
    }
  };

  const getVetList = () => {
    const reqList = vets?.map((li) => ({
      name: li?.name,
      value: li?.doctorId,
      department: li?.department,
    }));
    if (role === "ROLE_CLINIC") {
      reqList.unshift({
        name: `${clinicDet?.name} (Clinic)`,
        value: clinicDet?.id,
        id: clinicDet?.id,
      });
    }
    return reqList;
  };

  const getDepartmentIdByName = () => {
    return (
      clinicRoles?.find(
        (li) =>
          li?.type === "department" &&
          li?.roleName === selectedItem?.stockIssueDetails?.[0]?.department,
      )?.roleId ?? null
    );
  };

  const getUpdatedList = () => {
    dispatch(getStockIssues()).then((issRes) => {
      if (issRes?.payload) {
        const reqItem = issRes?.payload?.data?.find(
          (li) => li?.issueId === selectedItem?.issueId,
        );
        const reqAddedList = reqItem?.stockIssueDetails?.map((li, i) => {
          const currLocations = getLocationList(li?.stockId);
          // Find fromLocation by ID first, then by name/value as fallback
          let foundFromLocation = null,
            foundBatch = null;
          if (li?.batchId && li?.stockId) {
            const reqBat = clinicStocks
              ?.find((stc) => stc?.stockId === li?.stockId)
              ?.stockBatch?.find((bat) => bat?.batchId === li?.batchId);
            foundBatch = reqBat
              ? {
                  name: reqBat?.batchNo,
                  value: reqBat?.batchNo,
                  id: reqBat?.batchId,
                }
              : null;
          }
          if (li?.fromLocationId && currLocations?.length > 0) {
            foundFromLocation =
              currLocations?.find(
                (loc) =>
                  String(loc?.id) === String(li?.fromLocationId) ||
                  Number(loc?.id) === Number(li?.fromLocationId),
              ) ||
              currLocations?.find(
                (loc) =>
                  loc?.value === li?.fromLocationName ||
                  loc?.name === li?.fromLocationName,
              ) ||
              null;
          }
          const reqObj = {
            ...li,
            isRejected:
              li?.status?.toLowerCase() === "cancelled" ??
              li?.rejected ??
              false,
            issuedQuantity: li?.issueQuantity ?? 0,
            batchNumber: foundBatch,
            issueQuantity: li?.issueQuantity ?? li?.quantity,
            fromLocation: foundFromLocation,
            i,
          };
          return reqObj;
        });
        setAddedList(reqAddedList);
        onCloseReasonMod();
      }
    });
  };

  const handleDeleteItem = (i) => {
    const reqList = addedList
      ?.filter((li) => li?.i !== i)
      ?.map((li, i) => ({ ...li, i }));
    setAddedList(reqList);
  };

  const onSaveReason = () => {
    if (reason?.value?.trim()?.length === 0) {
      setReason({ ...reason, error: true });
      return;
    }
    const reqObj = {
      id: subItem?.id,
      remarks: reason?.value,
      issueQuantity: Number(subItem?.issueQuantity ?? 0),
      quantity: Number(subItem?.quantity ?? 0),
      status: "Cancelled",
      itemName: subItem?.itemName,
      fromLocationName: subItem?.fromLocation?.value ?? null,
      fromLocationId: subItem?.fromLocation?.id ?? null,
      toLocationName: subItem?.toLocation?.value ?? null,
      toLocationId: subItem?.toLocation?.id ?? null,
      mode: "manual",
      stockId: subItem?.stockId ?? null,
      batchId: subItem?.batchId ?? null,
      rejected: subItem?.rejected ?? false,
    };
    dispatch(
      updateStockIssues({ issueId: selectedItem?.issueId, data: [reqObj] }),
    ).then((res) => {
      if (res?.payload) {
        getUpdatedList();
        onCloseReasonMod();
      }
    });
  };

  const handleCancelIssue = (itm) => {
    setReason({ value: "", error: false });
    setSubItem(itm);
    setReasonModVsble(true);
  };

  const isItemNotValid = (itm) => {
    let isNotValid = false;
    const reqList = addedList?.map((li) => {
      if (li?.i === itm?.i) {
        const reqObj = {
          ...itm,
          qtyErr:
            itm?.issueQuantity?.length === 0 ||
            !itm?.issueQuantity ||
            Number(itm?.issueQuantity) < 1
              ? true
              : false,
          // fromLocationErr: !itm?.fromLocation?.id ? true : false,
          // toLocationErr: !itm?.toLocation?.id ? true : false,
        };
        if (
          reqObj?.qtyErr ||
          reqObj?.fromLocationErr
          // ||
          // reqObj?.toLocationErr
        ) {
          isNotValid = true;
        }
        return reqObj;
      }
      return li;
    });
    setAddedList(reqList);
    return isNotValid;
  };

  const getLocationByStockAndBatchId = (stckId = null, batId = null) => {
    if (!stckId || !batId) return null;
    const batchList = clinicStocks?.find(
      (stc) => stc?.stockId === stckId,
    )?.stockBatch;
    const reqBatch = batchList?.find((li) => li?.batchId === batId);
    return locations?.find((li) => li?.id === reqBatch?.location);
  };

  const onCompleteIssue = (itm) => {
    if (isItemNotValid(itm)) return;
    const reqBatch = getBatchById(itm?.stockId, itm?.batchNumber?.id);
    let reqToLocId = itm?.toLocationId ? itm?.toLocationId : 0;
    let reqToLocName = itm?.toLocationName ? itm?.toLocationName : "";
    const reqFromLocId = reqBatch?.locationId ?? null;
    const reqFromLocName = reqBatch?.location ?? null;
    if (!itm?.toLocationId || !itm?.toLocationName) {
      const reqFac = facilities?.find(
        (li) => li?.facilityId === selectedItem?.facilityId,
      );
      reqToLocId = reqFac?.primaryStorage;
      reqToLocName = reqFac?.name;
    }
    const reqObj = {
      id: itm?.id,
      issueQuantity: Number(itm?.issueQuantity),
      quantity: itm?.quantity,
      status:
        Number(itm?.issueQuantity) === Number(itm?.quantity)
          ? "Completed"
          : "Pending",
      itemName: itm?.itemName,
      fromLocationName: reqFromLocName ?? null,
      fromLocationId: reqFromLocId ?? null,
      toLocationName: reqToLocName ?? null,
      toLocationId: reqToLocId ?? null,
      mode: "manual",
      stockId: itm?.stockId ?? null,
      batchId: itm?.batchId ?? null,
      rejected: itm?.rejected ?? false,
    };
    if (!reqFromLocName) {
      const reqLoc = locations?.find((li) => li?.id === reqBatch?.locationId);
      if (reqLoc?.locationName) {
        reqObj.fromLocationName = reqLoc?.locationName ?? null;
      }
    }
    dispatch(
      updateStockIssues({ issueId: selectedItem?.issueId, data: [reqObj] }),
    ).then((res) => {
      if (res?.payload) getUpdatedList();
    });
  };

  const onCloseReasonMod = () => {
    setReasonModVsble(false);
    setSubItem(null);
    setReason({ value: "", error: false });
  };

  const onCloseRejectMod = () => {
    setRejectModVsble(false);
    setSubItem(null);
  };

  const onConfirmReject = () => {
    const reqObj = {
      id: subItem?.id,
      remarks: reason?.value,
      issueQuantity: Number(subItem?.issueQuantity ?? 0),
      quantity: Number(subItem?.quantity ?? 0),
      status: subItem?.status,
      itemName: subItem?.itemName,
      fromLocationName: subItem?.fromLocation?.value ?? null,
      fromLocationId: subItem?.fromLocation?.id ?? null,
      toLocationName: subItem?.toLocation?.value ?? null,
      toLocationId: subItem?.toLocation?.id ?? null,
      facilityId: subItem?.facilityId,
      // department: subItem?.department,
      mode: "manual",
      stockId: subItem?.stockId ?? null,
      batchId: subItem?.batchId ?? null,
      rejected: true,
    };
    dispatch(
      updateStockIssues({ issueId: selectedItem?.issueId, data: [reqObj] }),
    ).then((res) => {
      if (res?.payload) {
        getUpdatedList();
        onCloseRejectMod();
      }
    });
  };

  const handleRejectIssue = (itm) => {
    setSubItem(itm);
    setRejectModVsble(true);
  };

  const getStockQtyByFacility = (stckId = null, batId = null) => {
    if (!stckId || !batId || !modValues?.facility?.primaryStorage) return "-";
    const batchList = clinicStocks?.find(
      (stc) => stc?.stockId === stckId,
    )?.stockBatch;
    if (batchList?.length === 0 || !batchList) return "-";
    const reqBatch = batchList?.find(
      (bat) =>
        bat?.batchId === batId &&
        bat?.locationId === modValues?.facility?.primaryStorage,
    );
    return reqBatch?.quantity ?? "-";
  };

  const getStockQty = (stckId = null) => {
    if (!stckId) return "-";
    const batchList = clinicStocks?.find(
      (stc) => stc?.stockId === stckId,
    )?.stockBatch;
    if (batchList?.length === 0 || !batchList) return "-";
    return (
      batchList?.reduce((sum, item) => sum + (item?.quantity || 0), 0) ?? "-"
    );
  };

  const getBatchById = (stckId = null, batId = null) => {
    if (!stckId || !batId) return "-";
    const batchList = clinicStocks?.find(
      (stc) => stc?.stockId === stckId,
    )?.stockBatch;
    return batchList?.find((li) => li?.batchId === batId) ?? null;
  };

  const getStockBasedQtyWithToLocation = (stckId = null) => {
    if (
      !stckId ||
      (issueModVsble ? !selectedItem?.locationId : !modValues?.location?.id)
    )
      return "-";
    const batchList = clinicStocks?.find(
      (stc) => stc?.stockId === stckId,
    )?.stockBatch;
    const reqQty =
      batchList
        ?.filter(
          (li) =>
            li?.locationId ===
            (issueModVsble
              ? selectedItem?.locationId
              : modValues?.location?.id),
        )
        ?.reduce((sum, item) => sum + (item?.subunits || 0), 0) ?? "-";
    return reqQty;
  };

  return (
    <Container maxWidth="xl">
      <div className="back-white pv10">
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="flex-row-center"
        >
          <div className="flex-row">
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              style={{ width: "600px" }}
            >
              <CustomTextField
                placeholder="Search"
                fullWidth
                backgroundColor={AppColors.lightBlue2}
                value={searchValue}
                handleChange={(e) => setSearchValue(e.target.value)}
              />
            </Grid>
          </div>
          <div className="ml20">
            <div>
              <CustomButton
                text="Create Request"
                smallBtn
                onClick={handleCreate}
              />
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-row-ali-cen mt15 scrollx mh20 mbminus">
            {requestFilters?.map((sl) => (
              <Typography
                className={`gray4 fs14 ph10 pv5 br5 txt-semi-bold cursor mh5 ${
                  selFilterTypes?.includes(sl?.name)
                    ? "green-back3"
                    : "gray-back2"
                }`}
                key={sl?.name}
                onClick={() => handleFilterTypes(sl?.name)}
              >
                {sl?.name}
              </Typography>
            ))}
          </div>
        </Grid>
        <Typography className="font-medium fs12 gray28 ph30 mbminus mt15">
          Number of Records: {stockIssues?.totalRecords ?? 0}
        </Typography>
        <CustomTable
          columns={role === "ROLE_CLINIC" ? tblHdrs : tblHdrsOthers}
          datas={getTableHeaders()}
          grey
          stockIssue
          maxHeight="57vh"
        />
      </div>
      <CustomModal
        open={issueModVsble}
        onClose={onCloseIssueMod}
        header="Stock Requests"
        modalWidth={90}
        modal
      >
        <div className="scroll-60vh">
          <div className="light-blue-back pv10">
            <div className="flex-row-between-align-center">
              <div className="w25Per">
                <div className="flex-center">
                  <div>
                    <Typography className="gray29 fs12 font-medium">
                      Requested By
                    </Typography>
                    <Typography className="black22 fs12 txt-semi-bold">
                      {typeof selectedItem?.requestedBy === "string"
                        ? selectedItem?.requestedBy
                        : selectedItem?.requestedName
                          ? selectedItem?.requestedName
                          : (getVetById(selectedItem?.requestedBy)?.name ?? "")}
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="w25Per">
                <div className="flex-center">
                  <div>
                    <Typography className="gray29 fs12 font-medium">
                      Request Date
                    </Typography>
                    <Typography className="black22 fs12 txt-semi-bold">
                      {moment(new Date(selectedItem?.requestedDate)).format(
                        "DD MMM YYYY",
                      )}
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="w25Per">
                <div className="flex-center">
                  <div>
                    <Typography className="gray29 fs12 font-medium">
                      Request Type
                    </Typography>
                    <Typography className="black22 fs12 txt-semi-bold">
                      {
                        requestAndTransferRetriveEnum?.[
                          selectedItem?.requestType ?? ""
                        ]
                      }
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="w25Per">
                <div className="flex-center">
                  <div>
                    <Typography className="gray29 fs12 font-medium">
                      Location
                    </Typography>
                    <Typography className="black22 fs12 txt-semi-bold">
                      {getLocationById(selectedItem?.locationId) ?? ""}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="gry-hor-split2 mt15" />
          <div className="flex-row-ali-cen mt5">
            <div className="w20Per">
              <Typography className="font-bold gray29 fs12 ml5">
                Product Name
              </Typography>
            </div>
            <div className="w10Per">
              <Typography className="font-bold gray29 fs12">
                Requested Qty
              </Typography>
            </div>
            <div className="w15Per">
              <Typography className="font-bold gray29 fs12">
                Batch No. <span className="red-color">*</span>
              </Typography>
            </div>
            {/* <div className="w10Per">
              <Typography className="font-bold gray29 fs12">
                Available Qty <span className="red-color">*</span>
              </Typography>
            </div> */}
            <div className="w15Per">
              <Typography className="font-bold gray29 fs12">
                From Location
                {/* <span className="red-color">*</span> */}
              </Typography>
            </div>
            <div className="w10Per">
              <Typography className="font-bold gray29 fs12">
                Available Qty @ Location
              </Typography>
            </div>
            <div className="w15Per">
              <Typography className="font-bold gray29 fs12">Status</Typography>
            </div>
            <div className="w10Per">
              <Typography className="font-bold gray29 fs12">
                Issuing Qty <span className="red-color">*</span>
              </Typography>
            </div>
            <div className="w5Per">
              {!isPreview &&
              addedList?.some(
                (al) =>
                  al?.status?.toLowerCase() !== "cancelled" &&
                  al?.status?.toLowerCase() !== "completed" &&
                  !al?.rejected,
              ) ? (
                <Typography className="font-bold gray29 fs12">
                  Action
                </Typography>
              ) : null}
            </div>
            {/* <div className="w10Per" /> */}
          </div>
          <div className="gry-hor-split2 mt5" />
          {addedList?.map((al, i) => {
            const statShow =
              al?.status?.toLowerCase() === "cancelled" ||
              al?.status?.toLowerCase() === "completed" ||
              al?.rejected;
            return (
              <div className="flex-row mt10" key={`iss_${al?.i ?? i}`}>
                <div className="w20Per pr10">
                  {al?.stockId ? (
                    <Typography className="ml5 black22 fs14 txt-regular">
                      {al?.itemName}
                    </Typography>
                  ) : (
                    <CustomTextField
                      value={al?.itemName}
                      error={al?.itemNameErr}
                      helperText={al?.itemNameErr ? reqTxt : ""}
                      handleChange={(e) => {
                        onChange("itemName", e?.target?.value, al?.i);
                      }}
                      fullWidth
                      disabled={statShow || isPreview}
                    />
                  )}
                </div>
                <div className="w10Per">
                  <Typography className="ml5 black22 fs14 txt-regular">
                    {al?.quantity}
                  </Typography>
                </div>
                <div className="w15Per pr10">
                  {statShow ? (
                    <Typography className="ml5 black22 fs14 txt-regular">
                      {getBatchById(al?.stockId, al?.batchId)?.batchNo ?? "-"}
                    </Typography>
                  ) : (
                    <CustomSelect
                      list={getBatchList(al?.stockId)}
                      value={al?.batchNumber}
                      error={al?.batchErr}
                      helperText={al?.batchErr ? reqTxt : ""}
                      search
                      handleChange={(e, value) => {
                        onChange("batchNumber", value, al?.i);
                      }}
                      isBatchNumber
                      disabled={isPreview}
                    />
                  )}
                </div>
                {/* <div className="w10Per pr10">
                  <Typography className="align-center-wh ml5 black22 fs14 txt-regular h40">
                    {getStockQty(al?.stockId)}
                  </Typography>
                </div> */}
                <div className="w15Per pr10">
                  <Typography className="ml5 black22 fs14 txt-regular">
                    {al?.fromLocationName ??
                      al?.batchNumber?.locationName ??
                      // getBatchById(al?.stockId, al?.batchNumber?.id)
                      //   ?.location ??
                      "-"}
                    {/* {locations?.find(
                      (li) =>
                        li?.id ===
                        getBatchById(al?.stockId, al?.batchId)?.location
                    )?.locationName ?? "-"} */}
                  </Typography>
                  {/* <CustomSelect
                    list={getLocationsWithCategory(al?.stockId)}
                    // list={getLocationList(al?.stockId)}
                    value={al?.fromLocation}
                    error={al?.fromLocationErr}
                    helperText={al?.fromLocationErr ? reqTxt : ""}
                    select
                    handleChange={(e, value) => {
                      onChange("fromLocation", value, al?.i);
                    }}
                    // search
                    disabled={statShow}
                    // showQuantity
                    category
                  /> */}
                </div>
                <div className="w10Per pr10">
                  <Typography className="ml5 black22 fs14 txt-regular">
                    {al?.batchNumber?.quantity ??
                      getStockBasedQtyWithToLocation(al?.stockId)}
                  </Typography>
                </div>
                <div className="w15Per pr10">
                  <Typography
                    className={`
                      ${
                        al?.isRejected
                          ? "red-back2"
                          : al?.quantity === al?.issuedQuantity
                            ? "green-back5"
                            : al?.issuedQuantity > 0
                              ? "orange-back2"
                              : ""
                      } white-color status-con fs10 font-medium con-fit`}
                  >
                    {al?.isRejected
                      ? `Rejected: ${al?.issuedQuantity}/${al?.quantity} qty`
                      : al?.quantity === al?.issuedQuantity
                        ? `Issued: ${al?.issuedQuantity}/${al?.quantity} qty`
                        : al?.issuedQuantity > 0
                          ? `Partially Issued: ${al?.issuedQuantity}/${al?.quantity} qty`
                          : ""}
                  </Typography>
                </div>
                <div className="w10Per pr10">
                  {statShow ? (
                    <Typography className="ml5 black22 fs14 txt-regular">
                      {al?.issueQuantity ?? "-"}
                    </Typography>
                  ) : (
                    <CustomTextField
                      value={al?.issueQuantity}
                      error={al?.issQtyErr}
                      helperText={al?.issQtyErr ? reqTxt : ""}
                      handleChange={(e) => {
                        onChange("issueQuantity", e?.target?.value, al?.i);
                      }}
                      type="number"
                      fullWidth
                      disabled={statShow || isPreview}
                    />
                  )}
                </div>
                <div className="w5Per">
                  {statShow || isPreview ? null : (
                    <div className="flex-row-ali-cen mt10">
                      <img
                        src={require("../../../assets/images/png/tick.png")}
                        className="img-wh15 cursor"
                        onClick={() => onCompleteIssue(al)}
                      />

                      <img
                        src={require("../../../assets/images/png/crossRed.png")}
                        className="img-wh15 ml15 cursor"
                        onClick={() => handleCancelIssue(al)}
                      />
                    </div>
                  )}
                </div>
                {/* <div className="w10Per">
                  <div>
                    <CustomButton
                      text="Reject"
                      smallBtn
                      redBtn={!statShow}
                      grayBtn={statShow}
                      disabled={statShow}
                      onClick={() => handleRejectIssue(al)}
                    />
                  </div>
                </div> */}
              </div>
            );
          })}
          {/* <div className="flex-row-ali-cen mt5">
            <Typography className="txt-semi-bold fs14 black">Note: </Typography>
            <Typography className="font-medium fs14 ml5 gray3">
              Please note that all quantities are in subunits.
            </Typography>
          </div> */}
          {/* {addedList?.length > 0 ? (
            <div className="flex1-center mv10">
              <div>
                <CustomButton text="Submit" smallBtn onClick={onUpdateIssue} />
              </div>
            </div>
          ) : null} */}
        </div>
      </CustomModal>
      {modVsble ? (
        <StockRequestModal
          modVsble={modVsble}
          handleModClose={handleModClose}
          selectedItem={selectedItem ?? null}
        />
      ) : null}
      {/* <CustomModal
        open={modVsble}
        onClose={handleModClose}
        header="Create"
        modalWidth={70}
        modal
      >
        <div className="scroll-60vh">
          <div className="flex-row">
            <div className="w23Per">
              <Typography className="font-bold blue-color fs12 mb5">
                Request Type <span className="red-color">*</span>
              </Typography>
              <CustomSelect
                list={requestTypeList}
                value={modValues?.requestType}
                error={modValues?.requestTypeError}
                helperText={
                  modValues?.requestTypeError ? "This is required field" : ""
                }
                select
                handleChange={(e, value) => {
                  handleChange("requestType", value);
                }}
                search
              />
            </div>
            <div className="w23Per ml15">
              <Typography className="font-bold blue-color fs12 mb5">
                Location <span className="red-color">*</span>
              </Typography>
              <CustomSelect
                list={getLocationsByRequestType(
                  modValues?.requestType?.value ?? null,
                )}
                value={modValues?.location}
                error={modValues?.locationErr}
                helperText={
                  modValues?.locationErr ? "This is required field" : ""
                }
                select
                handleChange={(e, value) => {
                  handleChange("location", value);
                }}
                search
              />
            </div>
            {role === "ROLE_CLINIC" ? (
              <>
                <div className="w23Per ml15">
                  <Typography className="font-bold blue-color fs12 mb5">
                    Requested By <span className="red-color">*</span>
                  </Typography>
                  <CustomSelect
                    list={getVetList()}
                    value={modValues?.requestedBy}
                    error={modValues?.requestedByErr}
                    helperText={
                      modValues?.requestedByErr ? "This is required field" : ""
                    }
                    select
                    handleChange={(e, value) => {
                      handleChange("requestedBy", value);
                    }}
                    search
                  />
                </div>
                <div className="w23Per ml15">
                  <Typography className="font-bold blue-color fs12 mb5">
                    Request Date <span className="red-color">*</span>
                  </Typography>
                  <CustomTextField
                    value={modValues?.requestedDate}
                    handleChange={(e) => {
                      handleChange("requestedDate", e?.target?.value);
                    }}
                    mobileDate
                    fullWidth
                  />
                </div>
              </>
            ) : null}
          </div>

          <div className="flex-row-ali-cen ph20 mt20">
            <div className={role === "ROLE_CLINIC" ? "w30Per" : "w70Per"}>
              <Typography className="font-bold blue-color fs12">
                Product Name <span className="red-color">*</span>
              </Typography>
            </div>
            {role === "ROLE_CLINIC" ? (
              <div className="w20Per">
                <Typography className="font-bold blue-color fs12">
                  Batch No. <span className="red-color">*</span>
                </Typography>
              </div>
            ) : null}
            {role === "ROLE_CLINIC" ? (
              <>
                <div className="w15Per">
                  <Typography className="font-bold blue-color fs12">
                    Available Qty @ Location
                  </Typography>
                </div>
                <div className="w12Per">
                  <Typography className="font-bold blue-color fs12">
                    From Location
                    
                  </Typography>
                </div>
              </>
            ) : null}
            <div className={role === "ROLE_CLINIC" ? "w18Per" : "w25Per"}>
              <Typography className="font-bold blue-color fs12">
                {role === "ROLE_CLINIC" ? "Issuing" : "Requesting"} Qty
                <span className="red-color">*</span>
              </Typography>
            </div>
            <div className="w5Per" />
          </div>
          <div className="blue-hor-split mt5" />
          {addedList?.map((al, i) => {
            return (
              <div
                className="flex-row ph20 mt10 plan-bor"
                key={`iss_${al?.i ?? i}`}
              >
                <div
                  className={`${
                    role === "ROLE_CLINIC" ? "w30Per" : "w70Per"
                  } pr10`}
                >
                  <CustomSelect
                    list={getPresList()}
                    value={al?.name}
                    error={al?.nameErr}
                    helperText={al?.nameErr ? reqTxt : ""}
                    addNewSelect
                    mandatoryField
                    handleChange={(e) => {
                      onChange(
                        "name",
                        e?.value ?? e,
                        al?.i,
                        e?.stockId ?? null,
                      );
                    }}
                    plusBtn
                  />
                </div>
                {role === "ROLE_CLINIC" ? (
                  <div className="w20Per pr10">
                    <CustomSelect
                      list={getBatchList(al?.stockId)}
                      value={al?.batchNumber}
                      error={al?.batchErr}
                      helperText={al?.batchErr ? reqTxt : ""}
                      search
                      handleChange={(e, value) => {
                        onChange("batchNumber", value, al?.i);
                      }}
                      isBatchNumber
                    />
                  </div>
                ) : null}
                {role === "ROLE_CLINIC" ? (
                  <>
                    <div className="w15Per">
                      <Typography className="align-center-wh ml3 black22 fs14 txt-regular h40">
                        {getStockBasedQtyWithToLocation(al?.stockId)}
                      
                      </Typography>
                    </div>
                    <div className="w12Per pr10">
                      <Typography className="align-center-wh ml3 black22 fs14 txt-regular h40">
                        {getBatchById(al?.stockId, al?.batchNumber?.id)
                          ?.location ?? "-"}
                      </Typography>
                      
                    </div>
                  </>
                ) : null}
                <div
                  className={role === "ROLE_CLINIC" ? "w18Per pr10" : "w25Per"}
                >
                  <CustomTextField
                    value={al?.quantity}
                    error={al?.qtyErr}
                    helperText={al?.qtyErr ? reqTxt : ""}
                    handleChange={(e) => {
                      onChange("quantity", e?.target?.value, al?.i);
                    }}
                    type="number"
                    fullWidth
                  />
                </div>
                <div className="w5Per">
                  <div
                    className="cursor mt5"
                    onClick={() => handleDeleteItem(al?.i)}
                  >
                    <div className="flex-center">
                      <DeleteOutlineIcon sx={delBtn} />
                    </div>
                    <Typography className="red3 fs8 txt-semi-bold text-align-center">
                      Delete
                    </Typography>
                  </div>
                </div>
              </div>
            );
          })}
          <div className="flex-row-ali-cen mt5">
            <Typography className="txt-semi-bold fs14 black">Note: </Typography>
            <Typography className="font-medium fs14 ml5 gray3">
              Please note that all quantities are in subunits.
            </Typography>
          </div>
          {modValues?.location?.id ? (
            <div
              className="flex-row-ali-cen mt20 cursor"
              onClick={handleAddNew}
            >
              <div className="flex-center plus-icon">
                <AddIcon sx={addIcon} />
              </div>
              <Typography className="blue-color fs16 ml5 font-bold">
                Add
              </Typography>
            </div>
          ) : null}
          {addedList?.length > 0 ? (
            <div className="flex1-center mv10">
              <div>
                <CustomButton text="Submit" smallBtn onClick={handleSave} />
              </div>
            </div>
          ) : null}
        </div>
      </CustomModal> */}
      <CustomModal
        open={canModVsble}
        onClose={onCloseCanMod}
        header="Cancel Request"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to cancel the request?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={onConfrimCancel}
                smallBtn
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={onCloseCanMod} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={rejectModVsble}
        onClose={onCloseRejectMod}
        header="Reject"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to reject the item?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={onConfirmReject}
                smallBtn
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={onCloseRejectMod} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={reasonModVsble}
        onClose={onCloseReasonMod}
        header="Reason"
        modal
        modalWidth={40}
      >
        <Grid container spacing={1} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography className="font-bold gray29 fs12">
              Reason <span className="red-color">*</span>
            </Typography>
            <CustomTextField
              placeholder="Reason"
              fullWidth
              multiline
              value={reason?.value}
              handleChange={(e) =>
                setReason({
                  value: e?.target?.value,
                  error: e?.target?.value?.trim()?.length === 0 ? true : false,
                })
              }
              error={reason?.error}
              helperText={reason?.error ? reqTxt : ""}
            />
          </Grid>

          <div className="flex1-center mv20">
            <div>
              <CustomButton text="Save" smallBtn onClick={onSaveReason} />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </Container>
  );
};

export default StockRequest;
